import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => ({
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ variant }: any) => palette[variant].light,
    padding: `${spacing(3)}px ${spacing(3)}px `,
    paddingBottom: ({ brand }: any) => brand === 'ask' && spacing(2.5),
    boxShadow: `0px 1px 3px ${palette.background.contrastShadow}`,
    borderRadius: ({ rounded }: any) => rounded && '5px',
  },
  messageWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  messageText: {
    color: ({ variant }: any) => palette[variant].contrastMain,
    fontWeight: ({ bold }: any) => (bold ? 700 : 'normal'),
    fontSize: ({ bold }: any) => bold && '1rem',
  },
  icon: {
    paddingRight: spacing(2.5),
    display: 'flex',
    alignSelf: 'center',
  },
}));
